import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import {DocumentTitle} from '../widgets';
import getCategoryIcon from './CategoryIconPicker';
import actions from './search.actions';

import './SearchCategoryPage.css';

class SearchCategoryPage extends Component {
	handleKeyPress = event => {
		if (event.key === 'Enter') {
			this.props.history.push(`/search/${event.target.value}`);
		}
	};

	render() {
		const {searchFor, categories, query} = this.props;

		const searchForTitle = searchFor.charAt(0).toUpperCase() + searchFor.slice(1);
		const gridCategories = searchFor === 'provider' ? categories.provider : categories.community;
		return (
			<DocumentTitle title={`${searchForTitle} Search - B2Me`}>
				<main className="SearchPage-categories">
					<h1>Search for a {searchFor}</h1>

					<form
						className="SearchBox"
						action="."
						onSubmit={e => {
							e.preventDefault();
						}}>
						<input
							type="search"
							placeholder="Search by name, type, location, ..."
							value={query}
							onChange={e => this.props.setQuery(e.target.value)}
							onKeyPress={this.handleKeyPress}
						/>
						<Link to={`/search/${query}`}>
							<span className="icon icon-search" />
						</Link>
					</form>
					{searchFor !== 'user' && (
						<React.Fragment>
							<p className="subHeading">
								<em>Or explore the B2Me marketplace through {searchFor} categories</em>
							</p>
							<div className="SearchPage-searchGrid">
								{gridCategories &&
									gridCategories
										.filter(category => category !== 'Coaching and Mentoring')
										.map((category, idx) => (
											<Link
												className="gridLink"
												to={`/search/category:${category.replace(/ /g, '_')}?category=true`}
												key={idx}>
												<span className={`${getCategoryIcon(category)}`} />
												<span>{category}</span>
											</Link>
										))}
							</div>
						</React.Fragment>
					)}
				</main>
			</DocumentTitle>
		);
	}
}

const connectedSearchCategoryPage = connect(
	state => ({
		searchFor: state.search.searchFor,
		query: state.search.query,
		categories: state.categories
	}),
	dispatch => ({
		setQuery: query => dispatch(actions.searchSetQuery(query))
	})
)(SearchCategoryPage);

export default withRouter(connectedSearchCategoryPage);



// WEBPACK FOOTER //
// ./src/search/SearchCategoryPage.js